import Vue from "vue";
import App from "./App";
import router from "./router";
import { setLanguageParameter } from "./router/router.extensions";
import store from "./store";
import i18n from "./locales/i18n";
import VModal from "vue-js-modal";
import Toasted from "vue-toasted";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCog, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { startMain } from "@/services/scripts/main";
import { registerImageMapPro } from "@/services/scripts/imageMapPro.min";
import { WOW } from "wowjs";
import "./registerServiceWorker";
import SchemaSyncHandler from "./services/caching/schemasync";
import { forceReinitiliazationIfRequested } from "./services/offlineModeInitiliazer";
import { getWindow } from "./services/windowAdapter";
import "bootstrap";
import $ from "jquery";
import { isIeOrEdge } from "./services/browser";
import { languageAdapter } from "./services/languageAdapter";
import {
  initializeAnalytics
} from "@/services/analytics";

const window = getWindow();

window.$ = $;
window.jQuery = $;

if (window.location.search) {
  forceReinitiliazationIfRequested(window.location.search);
  window.location.search = "";
}

if (isIeOrEdge) {
  const splittedHash = window.location.hash.split("/");
  if (splittedHash.length === 1) {
    if (languageAdapter.supportedLanguages.includes(splittedHash[1])) {
      window.location.hash = "#/" + languageAdapter.getLanguageOfUser();
    }
  }
}

require("@fancyapps/fancybox");

setLanguageParameter(router);
startMain();
registerImageMapPro();

const wow = new WOW({ live: false });
wow.init();

Vue.config.productionTip = false;

library.add(faCog);
library.add(faTrashAlt);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VModal);
Vue.use(Toasted);
Vue.use(i18n);
SchemaSyncHandler.sync();
initializeAnalytics();

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
